import { ref } from 'vue'

const auth = {
    async install(app, options) {

        app.config.globalProperties.onLoginMethods = [];
        app.config.globalProperties.$user = ref(null);
        app.config.globalProperties.$userLoggedIn = ref(false);

        app.config.globalProperties.onLogin =  ( method) => {
            app.config.globalProperties.onLoginMethods.push(method) ;
        }

        app.config.globalProperties.getUser =  (key = null , new_value = null) => {

            if(new_value != null && key != null){
                app.config.globalProperties.$user.value.data[key] = new_value;
            }

            return key !== null
                        ? app.config.globalProperties.$user.value?.data[key]
                            : app.config.globalProperties.$user.value?.data;
        }

        app.config.globalProperties.isLoggedIn =  () => {
            return app.config.globalProperties.$userLoggedIn.value;
        }

        app.config.globalProperties.reGetUserData =  async () => {
            if (localStorage.getItem('token')) {
                await axios.get('auth/user').then(response => {
                    // app.config.globalProperties.onLoginMethod(response);


                    app.config.globalProperties.$user.value = response.data;

                    app.config.globalProperties.$userLoggedIn.value = true;

                    const object = app.config.globalProperties.onLoginMethods;
                    for (const property in object) {
                        if( typeof object[property] == 'function' ) {
                            object[property](response)
                        }
                    }

                }, response => {
                    localStorage.removeItem('token');
                });
            }
        }
        app.config.globalProperties.activation =  async (opts) => {
            await axios.post('activation',opts.data).then(response => {
                if (response.data?.status === true ) {

                    app.config.globalProperties.$user.value = response.data;

                    opts?.on_success(response);

                } else {
                    opts?.on_fail(response.data.message);
                }

                opts?.on_completed();

            }) .catch(function (error) {
                opts?.on_fail(error.response?.data?.message);
                opts?.on_completed();
            });
        }

        app.config.globalProperties.login =  async (opts ) => {
            await axios.post('login',opts.data).then(response => {
                if (response.data?.status === true ) {
                    localStorage.setItem('token', response.data.token);

                    axios.post('login-backend',opts.data).then(response => {}, response => {});

                    app.config.globalProperties.$user.value = response.data;

                    app.config.globalProperties.$userLoggedIn.value = true;

                    const object = app.config.globalProperties.onLoginMethods;
                    for (const property in object) {
                        if( typeof object[property] == 'function' ) {
                            object[property](response)
                        }
                    }

                    opts?.on_success(response);

                } else {
                    opts?.on_fail(response.data.message);
                }

                opts?.on_completed();

            }) .catch(function (error) {
                opts?.on_fail(error.response?.data?.message);
                opts?.on_completed();
            });
        }

        app.config.globalProperties.register =  async (opts) => {

            let formData = new FormData();
            Object.entries(opts?.data).forEach(([key, value]) => {
                formData.append(key, value);
            });

            await axios.post('register',
                formData
            ).then(response => {

                localStorage.setItem('token', response.data.token);

                app.config.globalProperties.$user.value = response.data;

                app.config.globalProperties.$userLoggedIn.value = true;


                opts?.on_success(response);
                opts?.on_completed();

            }) .catch(function (error) {
                opts?.on_fail(error.response.data.message , error.response);
                opts?.on_completed();
            });
        }

        app.config.globalProperties.logout =  async () => {
            await axios.post('logout-backend').then(response => {

            });
            await axios.post('logout')
                .then(response => {
                    if (response.data.status === true) {
                        app.config.globalProperties.$user.value = null;
                        app.config.globalProperties.$userLoggedIn.value = false;
                        localStorage.removeItem('token');
                        window.location.href = "/"
                        this.$router.push({name: 'home'});
                    }
                });
        }

        app.provide('auth', {
            onLogin : app.config.globalProperties.onLogin,
            user : app.config.globalProperties.getUser,
            isLoggedIn : app.config.globalProperties.isLoggedIn,
            logout : app.config.globalProperties.logout,
            login : app.config.globalProperties.login,
            register : app.config.globalProperties.register,
            activation : app.config.globalProperties.activation,
            reGetUser : app.config.globalProperties.reGetUserData,
        });

        app.config.globalProperties.authLogin = async () => {
            await app.config.globalProperties.reGetUserData();
        }

        await app.config.globalProperties.authLogin();


        if(typeof options['afterChecked'] == 'function'){
            options['afterChecked']();
        }
    }
}

export default auth;
